import { render, staticRenderFns } from "./CardName.vue?vue&type=template&id=418d80d5&scoped=true"
import script from "./CardName.vue?vue&type=script&lang=js"
export * from "./CardName.vue?vue&type=script&lang=js"
import style0 from "./CardName.vue?vue&type=style&index=0&id=418d80d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d80d5",
  null
  
)

export default component.exports